/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type School from 'linced-app/models/school';

// Proto: xero.Connection.
export default class Connection extends Model {
  declare [Type]: 'xero/connection';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string')
  declare url: string | undefined;

  @attr('string')
  declare code: string | undefined;

  @attr('string', { defaultValue: '' })
  declare authorizationCode: string;
}
